import { useEffect } from "react";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import { useDispatch, useSelector } from "react-redux";
import { GetSpecificJustificationsforTransferByProjectModificationRequestsId } from "../../../Redux/Reducers/ReportStage/JustificationsforTransfer";

const JustificationsforTransferForm = (props) => {
  const dispatch = useDispatch();

  const SpecificJustificationsforTransfer = useSelector(
    (state) =>
      state.JustificationsforTransfer
        .GetSpecificJustificationsforTransferByProjectModificationRequests
  );
  useEffect(() => {
    dispatch(
      GetSpecificJustificationsforTransferByProjectModificationRequestsId({
        projectModificationRequestsId: props.projectModificationRequestsId,
      })
    );
  }, [props.projectModificationRequestsId]);

  // console.log(
  //   SpecificJustificationsforTransfer.justificationsForTransferEmployee,
  //   "sssssssssssssdwdwdwd"
  // );

  useEffect(() => {
    if (SpecificJustificationsforTransfer != null) {
      props.setJustificationsForTransferEmployee(
        SpecificJustificationsforTransfer?.justificationsForTransferEmployee
      );
      props.setJustificationsforTransferBeneficiary(
        SpecificJustificationsforTransfer?.justificationsforTransferBeneficiary
      );
    }
  }, [SpecificJustificationsforTransfer]);

  return (
    <>
      <div className="form-grid">
        {props.JustificationsForEmployee ? (
          <>
            <TextAreaAHSF
              fieldsName={
                window.location.href.includes("TransferRequestDetails")
                  ? "JustificationsForTransferEmployee"
                  : window.location.href.includes(
                      "ProjectExtensionRequestDetails"
                    )
                  ? "JustificationsEmployee"
                  : ""
              }
              show={true}
              disabled={props.DisabledFieldTransfer}
              onChange={(e) => {
                // setItemDesecrabtion(e.target.value);
                props.setJustificationsForTransferEmployee(e.target.value);
              }}
              defaultValue={
                SpecificJustificationsforTransfer?.justificationsForTransferEmployee
              }
              showValidationMessage={false}
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </>
        ) : (
          <></>
        )}

        {props.JustificationsForSubmitter ? (
          <>
            <TextAreaAHSF
              fieldsName={
                window.location.href.includes("TransferRequestDetails")
                  ? "JustificationsforTransferBeneficiary"
                  : window.location.href.includes(
                      "ProjectExtensionRequestDetails"
                    )
                  ? "JustificationsBeneficiry"
                  : ""
              }
              show={true}
              disabled={props.DisabledFieldTransfer}
              onChange={(e) => {
                // setItemDesecrabtion(e.target.value);
                props.setJustificationsforTransferBeneficiary(e.target.value);
              }}
              defaultValue={
                SpecificJustificationsforTransfer?.justificationsforTransferBeneficiary
              }
              showValidationMessage={false}
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </>
        ) : (
          <></>
        )}
      </div>
      {props.AttachedAmendmentRequestTransfer ? (
        <>
          <div style={{ marginTop: "10px", width: "33%" }}>
            <label>
              مرفق طلب التعديل
              <span className="star" style={{ color: "red" }}>
                *
              </span>
            </label>
            <div style={{ marginTop: "20px" }}>
              <AttachmentASFH
                id={"AttachedAmendmentRequest"}
                title={"إضافة مرفق"}
                show={true}
                clear={false}
                disabled={props.DisabledFieldTransfer}
                AttachementType="Attachment"
                singleFile={props.File}
                readOnly={props.DisabledFieldTransfer}
                onChange={(e) => {
                  // setFileChange(fileChange + 1);
                  props.setFile(e.target.files[0]);
                }}
                showValidationMessage={false}
                validationMessage="يرجى تعبئة هذا الحقل"
              />
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default JustificationsforTransferForm;
